import {
  ACTUAL_DELETE_ACTUAL_COST_BEGIN,
  ACTUAL_DELETE_ACTUAL_COST_SUCCESS,
  ACTUAL_DELETE_ACTUAL_COST_FAILURE,
  ACTUAL_DELETE_ACTUAL_COST_DISMISS_ERROR,
} from './constants';


import{ SERVER_PATH,AXIOS_CONFIG } from '../../common/redux/constantes';
import axios from 'axios';

let tableRef = null;

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function deleteActualCost(_tableRef, actual_cost_id, project,args = {}) {
  tableRef = _tableRef;
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: ACTUAL_DELETE_ACTUAL_COST_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      axios.post(SERVER_PATH + '/actual_costs/edit', {
        actual_cost:{
        "actual_cost":actual_cost_id+'',
        "project":project,
        "status":"0"
        }
      }, AXIOS_CONFIG())
      .then(
        (res) => {
          dispatch({
            type: ACTUAL_DELETE_ACTUAL_COST_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: ACTUAL_DELETE_ACTUAL_COST_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissDeleteActualCostError() {
  return {
    type: ACTUAL_DELETE_ACTUAL_COST_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ACTUAL_DELETE_ACTUAL_COST_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        deleteActualCostPending: true,
        deleteActualCostError: null,
      };

    case ACTUAL_DELETE_ACTUAL_COST_SUCCESS:
      // The request is success
      tableRef.current && tableRef.current.onQueryChange();
      return {
        ...state,
        deleteActualCostPending: false,
        deleteActualCostError: null,
      };

    case ACTUAL_DELETE_ACTUAL_COST_FAILURE:
      // The request is failed
      return {
        ...state,
        deleteActualCostPending: false,
        deleteActualCostError: action.data.error,
      };

    case ACTUAL_DELETE_ACTUAL_COST_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        deleteActualCostError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/actual/redux/deleteActualCost.js